import { useAuth0 } from '@auth0/auth0-react'
import {
  Badge,
  Button,
  IconFrameButton,
  LogoImg,
  logoMetadata,
} from '@cleanlab/design-system/components'
import { IconMoon, IconSun } from '@cleanlab/design-system/icons'
import LogoLight from '@cleanlab/design-system/logos/128/logo-flush-black.png'
import LogoDark from '@cleanlab/design-system/logos/128/logo-flush-white.png'
import Link from 'next/link'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'

import ENV_VARS from '@/global/environmentVariables'
import { useUser } from '@/providers/account/UserContextProvider'
import { analytics } from '@/services/analytics'

import { BreadcrumbNav } from './BreadcrumbNav'

export function TopNav() {
  const { logout } = useAuth0()
  const { resolvedTheme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  // Avoid hydration mismatch by only rendering theme switcher after mount
  useEffect(() => {
    setMounted(true)
  }, [])

  const toggleTheme = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')
  }

  const logoutAuth = () => {
    if (ENV_VARS.VERCEL_ENV !== 'production') {
      analytics.track('user_logout')
      analytics.reset()
    }

    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  const { isCleanlabAdmin } = useUser()

  return (
    <nav className="flex shrink-0 justify-between overflow-hidden border-b border-border-1 p-6">
      <div className="flex w-full shrink items-center gap-8 overflow-hidden">
        <Link href="/" className="shrink-0">
          <LogoImg
            className="size-auto max-h-[32px] max-w-full"
            src={{ dark: LogoDark.src, light: LogoLight.src }}
            {...logoMetadata['128']['logo-flush']}
          />
        </Link>

        <BreadcrumbNav />
      </div>

      <div className="flex items-center gap-4">
        {isCleanlabAdmin && (
          <Badge className="min-h-full text-nowrap" hue="blue" size="large">
            Admin
          </Badge>
        )}
        {mounted && (
          <IconFrameButton
            icon={resolvedTheme === 'dark' ? <IconSun /> : <IconMoon />}
            aria-label="Toggle theme"
            variant="level1"
            size="medium"
            onClick={toggleTheme}
          />
        )}
        <Button variant="critical" className="self-end" onClick={logoutAuth}>
          Logout
        </Button>
      </div>
    </nav>
  )
}
